import { render } from "./PaymentHistory.vue?vue&type=template&id=12630c6c&scoped=true"
import script from "./PaymentHistory.vue?vue&type=script&lang=js"
export * from "./PaymentHistory.vue?vue&type=script&lang=js"

import "./PaymentHistory.vue?vue&type=style&index=0&id=12630c6c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12630c6c"]])

export default __exports__